export default {
    capitalize (value) {
        return value.toUpperCase()
    },
    lower (value) {
        return value.toLowerCase()
    },
    titleCase (value) {
        return value.split(' ').map(v => v[0].toUpperCase() + v.slice(1)).join(' ')
    },
    truncate (value, maxlen, postfix) {
        const postfixLen = postfix ? postfix.length: 0
        return value.slice(0, Math.max(0, maxlen - postfixLen))
    }
}